/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const queueEntries = sqliteTable('queue_entries', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  appointment_id: text('appointment_id'),
  queue_number: text('queue_number'),
  position: integer('position'),
  queue_date: text('queue_date'),
  source: text('source'),
  status: text('status'),
  priority: text('priority'),
  provider_id: text('provider_id'),
  service_id: text('service_id'),
  notes: text('notes'),
  tags: text('tags'),
  arrived_at: text('arrived_at'),
  called_at: text('called_at'),
  serving_at: text('serving_at'),
  done_at: text('done_at'),
  initial_fee_paid_at: text('initial_fee_paid_at'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
